import { render, staticRenderFns } from "./WeekSelect.vue?vue&type=template&id=6a804071&scoped=true"
import script from "./WeekSelect.vue?vue&type=script&lang=js"
export * from "./WeekSelect.vue?vue&type=script&lang=js"
import style0 from "./WeekSelect.vue?vue&type=style&index=0&id=6a804071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a804071",
  null
  
)

export default component.exports